import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LanguageService } from '../services/language.service';
import { isFeatureActive } from '../util/feature-active';

export function canActivateFeature(
  feature: string,
  redirectUrl = '/'
): CanActivateFn {
  return () => {
    const router = inject(Router);
    const languageService = inject(LanguageService);

    const location = languageService.locationCode;

    if (isFeatureActive(location, feature)) {
      return true;
    }

    return router.navigateByUrl(redirectUrl);
  };
}
